module.exports = __webpack_public_path__ + "media/images/vk-icon-7f56c5a266a9971c32a3ba4da5bc511f.png";